import { type AppState } from '../reducers';

export const getCompanyId = ({ global }: AppState) =>
  global?.company?.id as string; // The return can be undefined but for type sanity all locations are expexcting a string
